var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Watch, Component } from 'vue-property-decorator';
import CategoryService from '../../../../api/CategoryService';
import CommonService from '../../../../api/CommonService';
var LeftTree = (function (_super) {
    __extends(LeftTree, _super);
    function LeftTree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.filterText1 = "";
        _this.filterText = "";
        _this.data1 = [];
        _this.data2 = [];
        _this.defaultProps = {
            label: 'goods_type_name',
            id: "goods_type_id"
        };
        _this.defaultBusinessProps = {
            label: 'group_name',
            id: "group_id"
        };
        _this.tableFlag = '0';
        return _this;
    }
    LeftTree.prototype.watchFilterText = function (val) {
        this.$refs.tree0.filter(val);
    };
    LeftTree.prototype.watchFilterText1 = function (val) {
        this.$refs.tree1.filter(val);
    };
    LeftTree.prototype.created = function () {
        this.categoryService = CategoryService.getInstance();
        this.commonService = CommonService.getInstance();
        this.getLeftTree();
    };
    LeftTree.prototype.mounted = function () {
    };
    LeftTree.prototype.filterNode = function (value, data) {
        if (!value)
            return true;
        return data[this.defaultProps.label].indexOf(value) !== -1;
    };
    LeftTree.prototype.filterBusinessNode = function (value, data) {
        if (!value)
            return true;
        var label = data.group_id ? 'group_name' : 'business_name';
        return data[label].indexOf(value) !== -1;
    };
    LeftTree.prototype.nodeClick = function (data, node, target) {
        console.log('1111111111111');
        this.$emit('node-click', data);
    };
    LeftTree.prototype.selectChange = function (e) {
        this.tableFlag = e.name;
        this.$emit('changeShowBusiness', this.tableFlag);
        this.getLeftTree();
    };
    LeftTree.prototype.getLeftTree = function () {
        var _this = this;
        var params = {
            is_all: 1,
            from_system: 1,
            delivery_order_ids: String(this.orderIds)
        };
        this.commonService.getGroupchilds(params)
            .then(function (res) {
            _this.data1 = res.data.data;
            _this.autoSelect();
        });
        this.categoryService.getCategoryTree()
            .then(function (res) {
            _this.data2 = res.data.data;
            _this.autoSelect();
        });
    };
    LeftTree.prototype.autoSelect = function () {
        var _this = this;
        this.$nextTick(function () {
            var ref = "tree" + _this.tableFlag;
            var _a = _this.tableFlag === '0' ? [_this.data1, _this.defaultBusinessProps.id] : [_this.data2, _this.defaultProps.id], list = _a[0], key = _a[1];
            if (list && list.length > 0) {
                console.log(11, key, list[0][key], _this.$refs[ref]);
                _this.$refs[ref].setCurrentKey(list[0][key]);
                _this.$emit('node-click', _this.$refs[ref].getCurrentNode());
            }
        });
    };
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], LeftTree.prototype, "orderIds", void 0);
    __decorate([
        Watch("filterText")
    ], LeftTree.prototype, "watchFilterText", null);
    __decorate([
        Watch("filterText1")
    ], LeftTree.prototype, "watchFilterText1", null);
    LeftTree = __decorate([
        Component
    ], LeftTree);
    return LeftTree;
}(Vue));
export default LeftTree;
